// Import necessary modules and hooks from React and React Router
import { Navigate, Outlet } from "react-router";
import { useAuthContext } from '@synergy/microfrontend_core';

// Define a component named ProtectedRoute that receives a prop called redirectPath with a default value '/'
export const ProtectedRoute = ({ redirectPath = '/' }) => {
    // Use the useAuthContext() hook to get the user and token checking function from the authentication context
    const { user } = useAuthContext();

    // If there is no token, redirect to the route specified in the redirectPath prop
    if (!user) {
        return <Navigate to={redirectPath} replace />;
    }

    // If there is a token, render the Outlet component which will render nested routes
    return <Outlet />
}
